<template>
  <div class="wrapper" id="exportTips" :class="{'cancel':isHidden}">
    <p class="title">导出成功</p>
    <div class="cont" style="margin-right: 10px">
      <img src="../../assets/images/task/selected.png">
      <p>成功导出：<label class="common-theme-color">{{exportCont.totalCount}}</label></p>
      <p style="color: #999">无号码的线索不会导出</p>
    </div>
    <div class="cont">
      <img src="../../assets/images/task/suplur.png">
      <p>任务额度剩余：<label style="color:#F68B45;">{{taskQuota-usedTaskQuota}}</label></p>
      <p style="color: #999;margin-left: 54px;">【任务中心】可以查看导出的线索</p>
    </div>
    <el-button type="primary" v-if='exportCont.robot.config.externalUrl' style="margin-bottom: 12px;margin-top: 20px;" @click="goOut(exportCont.robot.config.externalUrl)">
      立即查看数据
    </el-button>
    <el-button @click="cancel">
      <label> 留在当前页 </label>
    </el-button>
  </div>
</template>
<script>
  import { mapActions,mapState } from "vuex";
  export default {
    props:['isHidden'],
    data() {
      return {
        surplurAmmount:800,
      };
    },
    computed: {
      ...mapState({
        exportCont:state => state.exportTips.exportCont,
        baseInfo: state => state.account.baseInfo,
        usedTaskQuota:state => state.user.usedTaskQuota,
        taskQuota :state => state.user.taskQuota
      })
    },
    methods: {
      ...mapActions(["fetchAccount",'getExportFlag','getExportStatus']),
      cancel(){
        this.getExportStatus(true);
        window.setTimeout(()=>{
          this.getExportFlag(false);
        },750);
      },
      goOut(url){
        if(url){
          window.open(url, '_blank');
        }
        this.cancel()
      },
    },
    mounted(){

    }
  };
</script>
<style lang="scss" scoped>
  .wrapper{
    position: fixed;
    right: 10px;
    top:76px;
    width: 330px;
    max-height:394px;
    z-index: 99999;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
    padding:30px 20px 34px;
    background: #fff;
    animation: move_eye 1s ease-in-out;
    .title{
      color: #333;
      font-size: 20px;
      margin-bottom: 27px;
      text-align: center;
    }
    .cont{
      width: 100%;
      height: 74px;
      border: 1px solid var(--contact-division-color);
      background: #fff;
      margin-bottom: 10px;
      position: relative;
      border-radius: 4px;
      font-size: 14px;
      padding: 14px 0 10px;
      img{
        position: absolute;
        left: 20px;
        top:50%;
        margin-top: -12px;
      }
      p{
        display: inline-block;
        margin-left: 60px;
        line-height: 22px;
      }
    }
  }
  @-webkit-keyframes move_eye { from { top:-400px; } to { top:76px;}  }
  @-moz-keyframes move_eye { from { top:-400px; } to { top:76px;}  }
  @-o-keyframes move_eye { from { top:-400px; } to { top:76px; }  }
  @keyframes move_eye { from { top:-400px; } to { top:76px;}  }

  .wrapper.cancel{
    animation: move_out 0.75s ease-in-out;
  }
  @-webkit-keyframes move_out { from { top:76px; } to { top:-400px;}  }
  @-moz-keyframes move_out  { from { top:76px; } to { top:-400px;}  }
  @-o-keyframes move_out { from { top:76px; } to { top:-400px;}  }
  @keyframes move_out  { from { top:76px; } to { top:-400px;} }
</style>



// WEBPACK FOOTER //
// src/components/account/exportTips.vue